const options = {
  5: "bg-slate-500/5",
  10: "bg-slate-500/10",
  25: "bg-slate-500/25",
  50: "bg-slate-500/50",
  75: "bg-slate-500/75",
  90: "bg-slate-500/90",
  100: "bg-slate-500",
};

const from = {
  5: "from-slate-500/5",
  10: "from-slate-500/10",
  25: "from-slate-500/25",
  50: "from-slate-500/50",
  75: "from-slate-500/75",
  90: "from-slate-500/90",
  100: "from-slate-500",
};

export default function getBackgroundSlate500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
